<template>
  <div>
    <LayoutHeaderWorks
      activeNav="比赛评选"
      :topColor="topColor"
      btnType="detail"
      :height="450"
    />
    <div class="container">
      <section class="nav">
        <ul v-if="navList.length > 1">
         <li
            :class="nav_item.name === worksClass.name ? 'activeNav' : ''"
            v-for="(nav_item, nav_index) in navList"
            :key="nav_index"
            @click="changeActive(nav_item)"
          >
            {{ nav_item.name }}
          </li>
        </ul>
      </section>
      <section class="works">
        <div class="works_container">
          <div class="top">
            <span>全部作品：{{ total }}</span>
            <span @click="toTop">查看榜单&gt;&gt;</span>
          </div>

          <ul v-if="worksList.length !== 0" class="bottom" ondragstart="return false">
            <li
              v-for="(work_item, work_index) in worksList"
              :key="work_index"
              @click="toDetail(work_item)"
            >
              <img :src="work_item.img_full" alt="" style="object-fit:cover;" />
              <div>
                <div class="left">
                  <h1 v-if="work_item.id < 10">0{{ work_item.id }}号</h1>
                  <h1 v-else>{{ work_item.id }}号</h1>
                  <h2>{{ work_item.title }}</h2>
                  <div v-if="work_item.show_opus == 1">
                    <img v-if="work_item.author_img_icon_full" :src="work_item.author_img_icon_full" alt="" />
                    <img v-else src="../../assets/images/default/headPic.png" alt="" />
                    <span>{{work_item.author}}</span>
                  </div>
                </div>
                <div class="right" style="margin-bottom:10px">
                  <div v-if="work_item.is_vote == 1">大众评审:{{ work_item.ticket }}票</div>
                  <div v-if="work_item.grade_type == 2" style="font-size: 14px;color: #cb4040;font-weight: bold;
                margin-bottom: 30px;
                text-align: right;">专家评审:{{ work_item.review_ticket }}票</div>
                
                  <div
                    v-if="
                      userInfo.expert_info.status_apply == undefined ||
                      userInfo.expert_info.status_apply == 0
                    "
                  >
                    <div
                      v-if="work_item.vote_status == 0 && work_item.is_vote==1"
                      class="vote"
                      @click="sendTicket($event, work_item)"
                    >
                      为TA投票
                    </div>
                    <div v-if="work_item.vote_status == 1 && work_item.is_vote==1" class="hasVote">
                      已投
                    </div>
                  </div>
                  <div v-else>
                    <div
                      v-if="work_item.grade_status == 0 && inviteStatus==true"
                      class="vote"
                      @click="comment($event, work_item)"
                    >
                      点评
                    </div>
                    <div v-if="work_item.grade_status == 1 && inviteStatus==true" class="hasVote">
                      已点评
                    </div>
                     <div v-if="work_item.grade_status == 2 && inviteStatus==true"  class="vote" @click="comment($event, work_item)">
                      撤销点评
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>

          <LayoutNoData background="white" v-else />
        </div>
      </section>

      <section class="paging">
        <LayoutPaging
          :total="total"
          @handleChange="changePage"
          style="background-color: #f2f2f2; padding-bottom: 56px"
        />
      </section>
    </div>
    <LayoutFooter />
  </div>
</template>

<script>
import MatchServices from "../../xx-vue/services/match";
import SystemServices from "../../xx-vue/services/system";
import WorksServices from "../../xx-vue/services/works";
import Storage from "../../xx-vue/utils/storage";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapMutations, mapActions } = createNamespacedHelpers("Work");
export default {
  data() {
    return {
      topColor: "",
      navList: [],
      activeNav: {},
      match_detail: {},
      userInfo: {
        expert_info: {
          id: undefined,
        },
      },
      inviteStatus: false,
    };
  },
  mounted() {
    this.initScroll();
    this.initData();
    const userInfo = Storage.getStorage("info");
    if (userInfo) {
      this.userInfo = userInfo;
      if (this.userInfo.expert_info.id) {
        this.getInviteStatus();
      }
    }
  },
  watch: {
    worksClass() {
      this.getWorksList({ project_id: ~~this.$route.query.project_id });
    },
    page() {
      this.getWorksList({ project_id: ~~this.$route.query.project_id });
    },
  },
  computed: {
    ...mapState(["worksClass", "worksList", "total", "page"]),
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.listenerFunction);
  },
  methods: {
    ...mapMutations(["changeClass", "changePage"]),
    ...mapActions(["getWorksList", "send_Ticket"]),
    //初始化滚动条监听
    initScroll() {
      document.addEventListener("scroll", this.handleScroll, true);
    },
    //监听滚动条移动
    handleScroll() {
      const pageY = window.pageYOffset;
      if (pageY === 0) {
        this.topColor = "background-color: rgba(0, 0, 0, 0.3)";
      } else {
        this.topColor = "background-color: rgb(22,22,22)";
      }
    },
    //更改激活Nav
    changeActive(val) {
      this.changeClass(val);
      this.$router.push(
        `/match/match_works?project_id=${this.$route.query.project_id}&group_id=${val.id}`
      );
    },
    //跳转榜单
    toTop() {
      this.$router.push(
        `/match/match_top?project_id=${this.$route.query.project_id}&group_id=${this.$route.query.group_id}`
      );
    },
    //跳转作品详情
    toDetail(item) {
      this.$router.push(
        `/match/work_detail?id=${item.id}&project_id=${this.$route.query.project_id}&group_id=${this.$route.query.group_id}`
      );
    },
    //初始化数据
    async initData() {
		
      const result = await SystemServices.getGroupAsync({
        project_id: ~~this.$route.query.project_id,
      });
      this.navList = result.data.list.map((v) => {
        return { name: v.name, id: v.id };
      });
      const active = this.navList.filter(
        (v) => v.id === ~~this.$route.query.group_id
      );
      this.changeClass(active[0]);
    },
    //获取是否可点评状态
    async getInviteStatus() {
      const inviteStatus = await WorksServices.getInviteStatus({
        project_id: ~~this.$route.query.project_id,
        expert_id: this.userInfo.expert_info.id,
      });
      if (inviteStatus.data.count === 0) {
        this.inviteStatus = false;
      } else {
        this.inviteStatus = true;
      }
    },
    //为TA投票
    async sendTicket(e, item) {
      e.stopPropagation();
      const result = await this.send_Ticket({
        project_id: ~~this.$route.query.project_id,
        item: item,
      });
      if (result) {
        this.$message.success("投票成功！");
      }
    },
    //点评
    async comment(e, item) {
      e.stopPropagation();
      this.$router.push(
        `/match/work_grade?id=${item.id}&project_id=${this.$route.query.project_id}&group_id=${this.$route.query.group_id}`
      );
    },
    
  },
};
</script>

<style lang="less" scoped>
.bnt{
  margin: 0px 20px;
    background: url("../../assets/images/match/bs-button-normol@2x.png") no-repeat;
    background-size: 100% 100%;
    color: #ffffff;padding-left: 30px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
    margin-top: 20px;
    display: inline-block;
    cursor: pointer;
}
.container {
  .nav {
    box-shadow: 0px 4px 8px #c7c7c7;
    position: relative;
    ul {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      li {
        margin-right: 68px;
        font-size: 18px;
        color: #333333;
        cursor: pointer;
        padding: 20px;
      }

      .activeNav {
        color: #f2252f;
        font-weight: bold;
        border-bottom: 2px solid #e24141;
      }
    }
  }
  .works {
    background-color: #f2f2f2;
    .works_container {
      padding: 48px 0;
      width: 1200px;
      margin: 0 auto;
      .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        & > :nth-child(1) {
          color: #989898;
          font-size: 18px;
        }
        & > :nth-child(2) {
          color: #f2252f;
          cursor: pointer;
          font-weight: bold;
        }
      }

      .bottom {
        display: flex;
        flex-wrap: wrap;
        li {
          margin-bottom: 30px;
          width: 30%;
          margin-right: 3.2%;
          background-color: #ffffff;
          font-size: 0;
          border-radius: 8px;
          cursor: pointer;
          & > img {
            width: 360px;
            height: 280px;
            border-radius: 8px;
          }
          & > div {
            display: flex;
            justify-content: space-between;
            padding: 10px;
            padding-bottom: 20px;

            .left {
              & > div {
                display: flex;
                align-items: center;
              }
              img {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                margin-right: 10px;
              }
              h1 {
                font-size: 14px;
                color: #656565;
                font-weight: normal;
                margin-bottom: 6px;
              }
              h2 {
                color: #333333;
                font-weight: normal;
                font-size: 18px;
                margin-bottom: 16px;
              }

              div {
                span {
                  color: #989898;
                  font-size: 14px;
                }
              }
            }

            .right {
              & > :first-child {
                font-size: 14px;
                color: #cb4040;
                font-weight: bold;
                // margin-bottom: 42px;
                text-align: right;
              }
              .vote {
                font-size: 14px;
                color: white;
                padding: 4px;
                background: url("../../assets/images/match/bs-button-normol@2x.png")
                  no-repeat;
                background-size: 100% 100%;
                cursor: pointer;
                text-align: center;
              }

              .hasVote {
                font-size: 14px;
                color: white;
                text-align: center;
                padding: 4px;
                background: url("../../assets/images/match/bs-button-disable@2x.png")
                  no-repeat;
                background-size: 100% 100%;
                cursor: no-drop;
              }
            }
          }
        }
      }
    }
  }
}
</style>